import {useQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

export default function useFaceLists({companyIds}: {companyIds: Array<number>}) {
  const query = useQuery({
    queryKey: [QueryKeyEnum.FACE_LISTS, companyIds],
    queryFn: async () => {
      return await api.facialRecognition.getList({
        filter: {
          companyIds,
        },
      })
    },
  })

  return query
}
